<template >
  <div id="footer">
    <div class="container-fluid">
      <v-row wrap>
        <v-col cols="12" lg="4" md="12" id="current-year">
          <div class="text-dark order-2 order-md-1">
            <span class="text-muted font-weight-bold mr-2"
              >{{ CurrentYear }}©</span
            >
            <a
              href="https://jciindia.in"
              target="_blank"
              class="text-dark-75 text-hover-primary"
              >JCI India</a
            >
          </div>
        </v-col>
        <v-col cols="12" lg="4" md="12" id="powered-by">
          <p>
            Powered by
            <img :src="HeartImagePath" alt="" width="15px" height="15px" />
            <a
              href="https://vaagai.org.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              Vaagai Tecknowledge</a
            >
          </p>
        </v-col>
        <v-col align="center" cols="12" md="4" lg="4" id="app-version">
          App version {{ AppVersion }}
        </v-col>
        <v-col align="center" cols="12" md="12" lg="12" id="version-info">
          {{ VersionInfo }}
        </v-col>
      </v-row>
      <br />
    </div>
  </div>
</template>
<script>
import companyConfig from "@/company_config.json";
import packageInfo from "@/../package.json";
import common from "@/Common.vue";

export default {
  mixins: [common],
  data() {
    return {
      CurrentYear: new Date().getFullYear(),
      HeartImagePath: "",
      AppVersion: packageInfo.version,
      VersionInfo: "",
    };
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      var server_url = companyConfig.apiURL;
      this.HeartImagePath = server_url + "assets/images/heart.png";
      console.log("imagepath" + this.HeartImagePath);
    },
  },
  beforeMount() {
    this.refreshPageData();
    console.log("beforeMount called");
    var url2 = "api/pages/version-info";
    var condition2 = {
      UserInterface: 6,
    };
    this.getPageDetails("VersionInfo", "", url2, condition2);
  },
};
</script>

<style scoped>
</style>